import { render } from "./SwitchCompany.vue?vue&type=template&id=58a4db34"
import script from "./SwitchCompany.vue?vue&type=script&lang=js"
export * from "./SwitchCompany.vue?vue&type=script&lang=js"

import exportComponent from "/Users/klous/Documents/beye/src/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__